import React, { useMemo } from "react";
import { faCalendar, faCalendarCircleMinus } from "web-fortawesome/npm/pro-light";
import { faCalendar as faCalendarSolid } from "web-fortawesome/npm/pro-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPresenceIconProps } from "./IPresenceIconProps";

/**
 * Presence Icon: Calendar
 * @param props - props from interface IPresenceIconProps
 * @returns - the calendar icon
 */
export const PresenceIconCalendar = (props: IPresenceIconProps): React.ReactElement => {
	const icon = useMemo(() => {
		if (!props.callProtection && !props.lineForwarded) {
			if (props.type === "busy")
				return faCalendarSolid;
			else if (props.type === "absent")
				return faCalendarCircleMinus;
			else
				return faCalendar;
		} else if (props.callProtection) {
			if (props.type === "busy")
				return faCalendarSolid;
			else
				return faCalendar;
		}
		return faCalendar;
	}, [props.type, props.callProtection, props.lineForwarded]);

	return (
		<FontAwesomeIcon
			className={props.className}
			icon={icon}
			fontSize={props.fontSize ?? 16}
			color={props.color ? props.color : `var(--presence-icon-type-${props.type ?? "free"})`}
		/>
	);
};
